
@if (isOpen()) {
  <div class="fixed inset-0 bg-black/90 flex items-center justify-center z-[1001] animate-fade-in-fast backdrop-blur-sm">
    <div [class]="hasAccepted() ? 'w-full max-w-6xl h-[85vh]' : 'w-full max-w-md'" 
         class="bg-slate-900 rounded-3xl shadow-2xl p-6 border border-slate-700 text-center relative overflow-hidden flex flex-col transition-all duration-300">
      
      @if (hasAccepted()) {
         <!-- Active Call View (IFrame) -->
         <div class="flex justify-between items-center mb-2 flex-shrink-0">
             <h2 class="text-lg font-bold text-white flex items-center gap-2">
                 <i class="fa-solid fa-video text-emerald-400"></i> Video Call
                 <span class="text-xs font-normal text-slate-400 bg-slate-800 px-2 py-0.5 rounded">{{ roomName() }}</span>
             </h2>
             <button (click)="close()" class="text-slate-400 hover:text-red-400 transition-colors bg-slate-800 hover:bg-slate-700 p-2 rounded-full w-10 h-10 flex items-center justify-center">
                 <i class="fa-solid fa-times text-xl"></i>
             </button>
         </div>
         <div class="flex-grow bg-black rounded-xl overflow-hidden relative border border-slate-700">
             <div #jitsiContainer class="w-full h-full"></div>
         </div>
      } @else {
         <!-- Waiting / Incoming View -->
         
         <!-- Background Pulse Effect for Incoming Call -->
         @if (isIncoming()) {
            <div class="absolute inset-0 z-0">
                <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-blue-500/20 rounded-full animate-ping"></div>
                <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-blue-500/30 rounded-full animate-pulse"></div>
            </div>
         }

         <div class="relative z-10 py-4">
            <!-- Icon / Avatar -->
            <div class="mb-8 mt-4">
                <div class="w-24 h-24 bg-gradient-to-tr from-blue-600 to-cyan-500 rounded-full flex items-center justify-center mx-auto shadow-lg shadow-blue-500/30"
                     [class.animate-bounce]="isIncoming()">
                    @if (isIncoming()) {
                        <i class="fa-solid fa-user-doctor text-5xl text-white"></i>
                    } @else {
                        <i class="fa-solid fa-video text-4xl text-white"></i>
                    }
                </div>
            </div>

            <!-- Status Text -->
            <h2 class="text-2xl font-bold text-white mb-2">
                @if (isIncoming()) {
                    สายเรียกเข้าจากแพทย์ (Incoming Call)
                } @else {
                    {{ 'modals.videoCall.waiting' | translate }}
                }
            </h2>
            
            <p class="text-slate-400 mb-6 font-mono bg-slate-800/50 py-1 px-3 rounded inline-block border border-slate-700">
                Room: {{ roomName() }}
            </p>

            <!-- Doctor Reminder -->
            @if (!isIncoming()) {
                <div class="mb-6 p-3 bg-red-900/30 border border-red-800/50 rounded-lg text-red-200 text-xs text-left flex items-start gap-2">
                    <i class="fa-solid fa-triangle-exclamation mt-0.5"></i>
                    <span><strong>REMINDER:</strong> Please take a screenshot during the call if needed for records.</span>
                </div>
            }

            <!-- Actions -->
            <div class="space-y-4">
                @if (isIncoming()) {
                    <!-- INCOMING CALL ACTIONS -->
                    <div class="flex gap-4 justify-center mt-8">
                        <button (click)="declineIncomingCall()" class="flex flex-col items-center gap-2 group">
                            <div class="w-16 h-16 bg-red-500 hover:bg-red-600 rounded-full flex items-center justify-center transition-all transform group-hover:scale-110 shadow-lg cursor-pointer border-4 border-slate-900">
                                <i class="fa-solid fa-phone-slash text-2xl text-white"></i>
                            </div>
                            <span class="text-sm text-slate-300 font-bold">ปฏิเสธ</span>
                        </button>

                        <button (click)="acceptIncomingCall()" class="flex flex-col items-center gap-2 group">
                            <div class="w-16 h-16 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center transition-all transform group-hover:scale-110 shadow-lg animate-pulse cursor-pointer border-4 border-slate-900">
                                <i class="fa-solid fa-phone text-2xl text-white"></i>
                            </div>
                            <span class="text-sm text-slate-300 font-bold">รับสาย</span>
                        </button>
                    </div>
                } @else {
                    <!-- OUTGOING / START ACTIONS -->
                    <button (click)="joinCall()" class="w-full bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-3 rounded-xl transition-all flex items-center justify-center gap-2 text-lg shadow-lg hover:-translate-y-1">
                        <i class="fa-solid fa-video"></i>
                        Start Video Call
                    </button>
                    
                    <button (click)="close()" class="w-full bg-slate-700 hover:bg-slate-600 text-slate-300 font-bold py-3 rounded-xl transition-colors mt-2">
                        {{ 'common.close' | translate }}
                    </button>
                }
            </div>
         </div>
      }

    </div>
  </div>
}
